import type { ReactNode } from 'react';

export const symbol_floor: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M270-150v-150q0-12.75 8.63-21.38Q287.25-330 300-330h150v-150q0-12.75 8.63-21.38Q467.25-510 480-510h150v-150q0-12.75 8.63-21.38Q647.25-690 660-690h150v-120q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v150q0 12.75-8.62 21.37Q852.75-630 840-630H690v150q0 12.75-8.62 21.37Q672.75-450 660-450H510v150q0 12.75-8.62 21.37Q492.75-270 480-270H330v150q0 12.75-8.62 21.37Q312.75-90 300-90H150q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h120Z"
		/>
	</svg>
);
